import { Component } from '@angular/core';
import { AuthService } from 'src/app/lib/auth.service';
import {
  CONTACT_STORE_URL,
  CONTACT_URL,
  CORPORATE_URL,
  FAQ_URL,
  NEWS_URL,
  PRIVACY_URL,
  SITE_URL,
  TERM_URL,
  USAGE_URL,
} from '../../constants';
import { GlobalHeaderCommands } from './global-header.commands';
import { GlobalHeaderQueries } from './global-header.queries';

interface SubMenuVisibility {
  settings: boolean;
  help: boolean;
  about: boolean;
}

@Component({
  selector: 'app-global-header',
  templateUrl: './global-header.component.html',
  styleUrls: ['./global-header.component.scss'],
})
export class GlobalHeaderComponent {
  year = new Date().getFullYear();
  isMenuOpen = false;
  showSignOutModal = false;

  // メニューの開閉状態
  subMenuVisivblity: SubMenuVisibility = {
    settings: false,
    help: false,
    about: false,
  };

  // 各種リンクURL
  readonly faqURL = FAQ_URL;
  readonly usageURL = USAGE_URL;
  readonly termURL = TERM_URL;
  readonly privacyURL = PRIVACY_URL;
  readonly siteURL = SITE_URL;
  readonly contactURL = CONTACT_URL;
  readonly corporateURL = CORPORATE_URL;
  readonly contactStoreURL = CONTACT_STORE_URL;
  readonly newsURL = NEWS_URL;

  constructor(
    public readonly queries: GlobalHeaderQueries,
    private readonly commands: GlobalHeaderCommands,
    private readonly auth: AuthService,
  ) {}

  isSignedIn() {
    return this.auth.isSignedIn();
  }

  onClickSignOutLink() {
    this.showSignOutModal = true;
  }

  onCancelSignOut() {
    this.showSignOutModal = false;
  }

  onConfirmSignOut() {
    this.commands.signOut();
    this.showSignOutModal = false;
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  toggleSubMenu(key: keyof SubMenuVisibility) {
    this.subMenuVisivblity[key] = !this.subMenuVisivblity[key];
  }

  closeMenu() {
    this.isMenuOpen = false;
  }
}
